module.exports = __webpack_public_path__ + "static/media/2.6d23f607.jpg";